'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedSize = require('I18n/components/FormattedSize');

var _FormattedSize2 = _interopRequireDefault(_FormattedSize);

var _UIFileAttachment = require('UIComponents/attachment/UIFileAttachment');

var _UIFileAttachment2 = _interopRequireDefault(_UIFileAttachment);

var _UITruncateString = require('UIComponents/text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DocumentAttachment = function (_React$Component) {
  _inherits(DocumentAttachment, _React$Component);

  function DocumentAttachment() {
    _classCallCheck(this, DocumentAttachment);

    return _possibleConstructorReturn(this, (DocumentAttachment.__proto__ || Object.getPrototypeOf(DocumentAttachment)).apply(this, arguments));
  }

  _createClass(DocumentAttachment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onLoad();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          size = _props.size;


      return _react2.default.createElement(_UIFileAttachment2.default, {
        fileName: _react2.default.createElement(
          _UITruncateString2.default,
          null,
          name
        ),
        fileInfo: _react2.default.createElement(_FormattedSize2.default, { value: size })
      });
    }
  }]);

  return DocumentAttachment;
}(_react2.default.Component);

DocumentAttachment.propTypes = {
  name: _react.PropTypes.string.isRequired,
  onLoad: _react.PropTypes.func,
  size: _react.PropTypes.number.isRequired
};

DocumentAttachment.defaultProps = {
  onLoad: function onLoad() {}
};

exports.default = DocumentAttachment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/attachments/DocumentAttachment.js
// module id = 1137
// module chunks = 2 3